import type Expand from '@arcgis/core/widgets/Expand'

export function handleExpand(openedExpand: Expand, expands: Expand[]) {
  expands.forEach((expand) => {
    if (expand !== openedExpand && expand.expanded) {
      expand.expanded = false
    }
  })
}

export function handleDocumentClick(event: MouseEvent, expands: Expand[]) {
  const containers = expands.map(
    (expand) => expand.container as HTMLElement | null
  )

  const targetNode = event.target as Node | null

  if (containers.some((node) => !node) || !targetNode) {
    return
  }

  // If click is inside any expand widget, do nothing
  if (containers.some((node) => node!.contains(targetNode))) {
    return
  }

  // Collapse all expands if open
  expands.forEach((expand) => {
    if (expand.expanded) {
      expand.expanded = false
    }
  })
}
